import http from './http';

export default {
  all() {
    return http().get(`/v1/task_lists`);
  },
  get(id) {
    return http().get(`/v1/task_lists/${id}`);
  },
  create(data) {
    return http().post(`/v1/task_lists`, data);
  },
  update(data) {
    return http().put(`/v1/task_lists/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/task_lists/${id}`);
  },
  detachTemplate(id, templateId) {
    return http().delete(`/v1/task_lists/${id}/template/${templateId}`);
  },
  attachTemplate(id, templateId) {
    return http().post(`/v1/task_lists/${id}/template/${templateId}`);
  },
  attachToAutomation(id, automationId) {
    return http().post(`/v1/task_lists/${id}/automation/${automationId}`);
  },
}
